import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pt-6" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_3 = {
  for: "title",
  class: "font-semibold"
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col gap-2"
}
const _hoisted_5 = {
  for: "title",
  class: "font-semibold"
}
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = {
  for: "title",
  class: "font-semibold"
}
const _hoisted_8 = { class: "flex flex-col justify-between gap-6 sm:flex-row" }
const _hoisted_9 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_10 = { for: "date" }
const _hoisted_11 = { class: "flex flex-row gap-6" }
const _hoisted_12 = { class: "flex flex-col gap-2 max-w-20" }
const _hoisted_13 = { for: "startTime" }
const _hoisted_14 = { class: "flex flex-col gap-2 max-w-20" }
const _hoisted_15 = { for: "endTime" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h6", null, /*#__PURE__*/_toDisplayString("Tipo de Aula"), -1)
const _hoisted_17 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_18 = { class: "flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "internalClass",
  class: "ml-2"
}, /*#__PURE__*/_toDisplayString("Aula interna"), -1)
const _hoisted_20 = { class: "flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "externalClass",
  class: "ml-2"
}, /*#__PURE__*/_toDisplayString("Aula externa"), -1)
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "flex flex-col justify-between gap-2" }
const _hoisted_24 = { for: "externalLink" }
const _hoisted_25 = { class: "flex flex-row items-center gap-2" }
const _hoisted_26 = { class: "text-h-neutral-500 text-sm" }
const _hoisted_27 = {
  key: 3,
  class: "flex flex-col gap-4"
}
const _hoisted_28 = { class: "flex flex-row justify-between gap-2" }
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = { class: "flex flex-row justify-between gap-2" }
const _hoisted_31 = { class: "w-full" }
const _hoisted_32 = { class: "flex items-center justify-end w-full gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("form", {
      autocomplete: "off",
      class: "flex flex-col gap-6",
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"]))
    }, [
      (!_ctx.hasCourse)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("classes.event.form.inputs.class")), 1),
            _createVNode(_component_AutoComplete, {
              modelValue: _ctx.className,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.className) = $event)),
              class: _normalizeClass(
            _ctx.vuelidate$.eventForm.classroom.$error
              ? 'p-invalid complete-custom'
              : 'complete-custom'
          ),
              placeholder: _ctx.$t('classes.event.form.inputs.searchClass'),
              suggestions: _ctx.classes,
              optionLabel: "name",
              onComplete: _ctx.searchClassByName,
              onItemSelect: _ctx.onSelectClass,
              onClear: _ctx.clearInputClass,
              dropdown: ""
            }, null, 8, ["modelValue", "class", "placeholder", "suggestions", "onComplete", "onItemSelect", "onClear"]),
            _createVNode(_component_Errors, {
              errors: _ctx.vuelidate$.eventForm.classroom.$errors
            }, null, 8, ["errors"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.hasCourse)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("classes.event.form.inputs.course")), 1),
            _createVNode(_component_AutoComplete, {
              modelValue: _ctx.courseName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.courseName) = $event)),
              class: _normalizeClass([{ 'p-invalid': _ctx.vuelidate$.eventForm.course.$error }, "complete-custom"]),
              optionLabel: "name",
              placeholder: _ctx.$t('classes.event.form.inputs.searchCourse'),
              suggestions: _ctx.courses,
              forceSelection: true,
              disabled: _ctx.enableCourse,
              onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCoursesByClassroomId(_ctx.eventForm.classroom as string))),
              onItemSelect: _ctx.onSelectCourse,
              dropdown: ""
            }, null, 8, ["modelValue", "class", "placeholder", "suggestions", "disabled", "onItemSelect"]),
            _createVNode(_component_Errors, {
              errors: _ctx.vuelidate$.eventForm.course.$errors
            }, null, 8, ["errors"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("fieldset", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("classes.event.form.inputs.title")), 1),
        _createVNode(_component_InputText, {
          type: "text",
          id: "title",
          modelValue: _ctx.eventForm.name,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.eventForm.name) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.vuelidate$.eventForm.name.$error }),
          maxlength: 50,
          minLength: 2,
          placeholder: _ctx.$t('classes.event.form.inputs.titlePlaceholder')
        }, null, 8, ["modelValue", "class", "placeholder"]),
        _createVNode(_component_Errors, {
          errors: _ctx.vuelidate$.eventForm.name.$errors,
          actualLength: _ctx.eventForm.name.length,
          maxLength: 50,
          minLength: 2
        }, null, 8, ["errors", "actualLength"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("fieldset", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("classes.event.form.inputs.date")), 1),
          _createVNode(_component_Calendar, {
            inputId: "eventdate-input",
            modelValue: _ctx.eventForm.date,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.eventForm.date) = $event)),
            dateFormat: "dd/mm/yy",
            placeholder: _ctx.$t('classes.event.form.inputs.datePlaceholder'),
            manualInput: false,
            minDate: _ctx.today,
            class: _normalizeClass({ 'p-invalid': _ctx.vuelidate$.eventForm.date.$error })
          }, null, 8, ["modelValue", "placeholder", "minDate", "class"]),
          _createVNode(_component_Errors, {
            errors: _ctx.vuelidate$.eventForm.date.$errors
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("fieldset", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("classes.event.form.inputs.startTime")), 1),
            _createVNode(_component_InputMask, {
              id: "startTime",
              modelValue: _ctx.eventForm.startTime,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.eventForm.startTime) = $event)),
              mask: "99:99",
              placeholder: "00:00",
              class: _normalizeClass(_ctx.vuelidate$.eventForm.startTime.$error ? 'p-invalid' : '')
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.vuelidate$.eventForm.startTime.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("fieldset", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("classes.event.form.inputs.endTime")), 1),
            _createVNode(_component_InputMask, {
              id: "endTime",
              modelValue: _ctx.eventForm.endTime,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.eventForm.endTime) = $event)),
              mask: "99:99",
              placeholder: "00:00",
              class: _normalizeClass({ 'p-invalid': _ctx.vuelidate$.eventForm.endTime.$error })
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.vuelidate$.eventForm.endTime.$errors
            }, null, 8, ["errors"])
          ])
        ])
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_RadioButton, {
            modelValue: _ctx.classType,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.classType) = $event)),
            inputId: "internalClass",
            name: "classType",
            value: "internal"
          }, null, 8, ["modelValue"]),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_RadioButton, {
            modelValue: _ctx.classType,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.classType) = $event)),
            inputId: "externalClass",
            name: "classType",
            value: "external"
          }, null, 8, ["modelValue"]),
          _hoisted_21
        ])
      ]),
      (_ctx.isExternal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("fieldset", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("classes.event.form.inputs.externalLink")), 1),
              _createVNode(_component_InputText, {
                id: "externalLink",
                modelValue: _ctx.eventForm.url,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.eventForm.url) = $event)),
                maxlength: 200,
                placeholder: 
              _ctx.$t('classes.event.form.inputs.externalLinkPlaceholder')
            ,
                class: _normalizeClass({ 'p-invalid': _ctx.vuelidate$.eventForm.url.$error })
              }, null, 8, ["modelValue", "placeholder", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.vuelidate$.eventForm.url.$errors
              }, null, 8, ["errors"]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_v_icon, {
                  name: "md-info-outlined",
                  scale: 0.8
                }, null, 8, ["scale"]),
                _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Não é permitido o cadastro de link recorrente",
                  en: "Recurring link registration is not allowed",
                })), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("fieldset", _hoisted_28, [
              _createVNode(_component_v_icon, {
                name: "md-peoplealt-round",
                scale: 1.2
              }, null, 8, ["scale"]),
              _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("classes.event.form.inputs.public")), 1),
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.eventForm.isPublic,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.eventForm.isPublic) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("fieldset", _hoisted_30, [
              _createVNode(_component_v_icon, {
                name: "md-videocameraback-round",
                scale: 1.2
              }, null, 8, ["scale"]),
              _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("classes.event.form.inputs.record")), 1),
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.eventForm.record,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.eventForm.record) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_Button, {
          id: "cancel-btn",
          label: _ctx.$t('classes.event.form.buttons.cancel'),
          class: "btn-outline m-0",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onCloseForm()))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          id: "submit-btn",
          type: "submit",
          label: _ctx.$t('classes.event.form.buttons.save'),
          class: "btn-primary m-0",
          loading: _ctx.loading
        }, null, 8, ["label", "loading"])
      ])
    ], 32)
  ]))
}